import React from 'react'
import "./Tag.css";

const Tag = (props) => {
  return (
    <div className="tag" id={props.id}>
      <img  src={props.src} alt="" />
    </div>
  )
}

export default Tag
